import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../shared/services/auth.service';
import { CouponsUmsService } from '../../../pages/coupons-ums/coupons-ums.service';
import { Coupon } from '../../../pages/coupons-ums/coupon.model';

@Component({
  selector: 'app-coupon-dialog',
  templateUrl: './coupon-dialog.component.html',
  styleUrls: ['./coupon-dialog.component.scss'],
  providers: [ CouponsUmsService ]
})
export class CouponDialogComponent implements OnInit {
  public form: FormGroup;
  public passwordHide: boolean = true;
  public coupon: Coupon;
  public roleId: number;
  public hasRedemptions = false;
  public toppings = new FormControl();
  public types = [{code: 'FIXED',name:"Cantidad"},{code: 'PERCENT',name:"Porcentaje"}];
  public statuses = [{code: 'ACTIVE',name:"Activo"},{code: 'INACTIVE',name:"Inactivo"}];
  constructor(
      public couponsService: CouponsUmsService,
      public dialogRef: MatDialogRef<CouponDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public fb: FormBuilder,
      private toastr: ToastrService
  ) {

    this.coupon = data.coupon;
    this.hasRedemptions = data.coupon? data.coupon.id && data.coupon.redemptions.length > 0 : false;

    this.form = this.fb.group({
      id: null,
      created_by: AuthService.getUser().id,
      code: [{ value: this.coupon ? this.coupon.code : null, disabled: this.hasRedemptions }, Validators.compose([Validators.required])],
      value: [{ value: this.coupon ? this.coupon.value : null, disabled: this.hasRedemptions }, Validators.compose([Validators.required])],
      type: [{ value: this.coupon ? this.coupon.type : null, disabled: this.hasRedemptions }, Validators.compose([Validators.required])],
      start_at: [{ value: this.coupon ? this.coupon.start_at: null, disabled: this.hasRedemptions }],
      end_at: [{ value: this.coupon ?  this.coupon.end_at : null, disabled: this.hasRedemptions }],
      max_redemptions_global: [{ value: this.coupon ? this.coupon.max_redemptions_global : 1, disabled: this.hasRedemptions }],
      scope: 'INSCRIPCION',
      status: [this.coupon ? this.coupon.status : 'ACTIVE'],
    });

    console.log('CONSTRUCTOR_USER_DIALOG');
  }

  ngOnInit() {
    if (this.coupon) {
      this.form.setValue(this.coupon);
    } else {
      this.coupon = new Coupon();
    }
  }

  save(coupon: Coupon): void {
    if (coupon && coupon.id == null) {
        this.couponsService.saveCoupon(coupon).subscribe((exist:any) => {
          if(exist.error){
            this.toastr.warning(exist.message);
          }else {
            this.toastr.info('Cupón creado');
            this.dialogRef.close(coupon);
          }
        },
        (err) => {
          if("code" in err.error){
            this.toastr.error('Ya existe un código con este nombre. Utiliza otro.');  
          }else {
            this.toastr.error('Error guardando');
          }
        }
      );
    }else {
      this.couponsService.updateCoupon(coupon).subscribe((exist:any) => {
          if(exist.error){
            this.toastr.warning(exist.message);
          }else {
            this.toastr.info('Cupón actualizado');
            this.dialogRef.close(coupon);
          }
        },
        (err) => {
          this.toastr.error('Error actualizando');
        }
      );
    }


  }

  close(): void {
    this.dialogRef.close(this.coupon);
  }

}
